"use strict";

exports.__esModule = true;
exports.TimelineValueThumbnail = TimelineValueThumbnail;
var _react = _interopRequireDefault(require("react"));
var _Measures = require("../../Measures");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for TimelineValueWidget.
 */
function TimelineValueThumbnail(_ref) {
  var timelineName = _ref.timelineName,
    _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height;
  var timeline = (0, _timelineDefinitions.getTimelineDefinition)(timelineName);
  var value;
  if (!timeline) {
    value = Math.round(Math.random() * 100).toString();
  }
  if (timeline.name === _timelineDefinitions.TIME_SERIES_CLASSIFICATION) {
    value = "Producing";
  } else if (timeline.name === _timelineDefinitions.TIME_SERIES_SHIFT) {
    value = "Shift 1";
  } else if (timeline.name === _timelineDefinitions.TIME_SERIES_CONDITION) {
    value = "GOOD";
  } else if (timeline.name === _timelineDefinitions.TIME_SERIES_PROCESS) {
    value = "AB-12-34";
  } else if (timeline.name === _timelineDefinitions.TIME_SERIES_KIND) {
    value = "XYZ-987";
  } else if (timeline.name === _timelineDefinitions.TIME_SERIES_INSTANCE) {
    value = "INST-1337";
  } else {
    value = Math.round(Math.random() * 100).toString();
  }
  return /*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
    x: x,
    y: y,
    width: width,
    height: height,
    value: value
  });
}